import { render, staticRenderFns } from "./BCorpBadge.vue?vue&type=template&id=1b6738f6&"
import script from "./BCorpBadge.vue?vue&type=script&lang=ts&"
export * from "./BCorpBadge.vue?vue&type=script&lang=ts&"
import style0 from "./BCorpBadge.vue?vue&type=style&index=0&id=1b6738f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports